// 客户
import { dataTimestampToFormat } from '/@/utils/common';
import { defHttp } from '/@/utils/http/axios';

enum Api {
  CustomerList = '/customer/index',
  CustomerDetail = '/customer/read',
  CustomerCreate = '/customer/save',
  CustomerModifyCustomerTypes = '/customer/modifyCustomerTypes',
  CustomerAllotAction = '/allot/allotAction',
  CustomerUpdate = '/customer/update',
  CustomerTypeList = '/customer/getCustomerTypes',
  CustomerGetFinanceCustomer = '/customer/getFinanceCustomer',
  CustomerData = '/api/getCustomerData',
  AddWeCustomerRelation = '/wecustomer/addWeCustomerRelation',
  toBindCustomerManager = '/wecustomer/toBindCustomerManager',
  CustomerTransferExamine = '/customer/transferExamine',
  GetCustomerOwners = '/customer/getCustomerOwners',
  UpdateTYCData = '/customer/updateTYCData',
  GetCustomerYearSales = '/customer/getCustomerYearSalesData',
  ECCustomerHandle = '/customer/ECCustomerHandle',
  GetECCustomerList = '/customer/getECCustomerList',
  GetCreateCustomerList = '/customer/getCreateCustomerList',
  KeyCustomerHandle = '/customer/keyCustomerHandle',
  ActiveCustomer = '/customer/activeCustomer',
  TransferImport = '/customer/transferImport',
  CustomerOrderWayChange = '/customer/orderWayChange',
  GetCustomerByName = '/customer/getCustomerByName',
  GetSpecialDelayCustomer = '/customer/getSpecialDelayCustomer',
  CheckDelayOrderByOrderId = '/customer/checkDelayOrderByOrderId',
  SpecialDelayCustomerSave = '/customer/specialDelayCustomerSave',
  SpecialDelayCustomerDelete = '/customer/specialDelayCustomerDelete',
  CustomerRuleList = '/customerRule/list',
  CustomerRuleStatusCounts = '/customerRule/statusCounts',
  CustomerRuleSave = '/customerRule/save',
  CustomerRuleStatus = '/customerRule/status',
  CustomerRuleHistory = '/customerRule/history',
}

// 新增下单账号关联关系
export const addWeCustomerRelationApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.AddWeCustomerRelation,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 下单账号绑定客户经理
export const toBindCustomerManagerApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.toBindCustomerManager,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 列表
export const getCustomerListApi = async (params: any) => {
  const res = await defHttp.post<any>({
    url: Api.CustomerList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
  res.data = dataTimestampToFormat(res.data);
  return res;
};

// 详情
export const getCustomerDetailApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerDetail,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 新增
export const createCustomerApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerCreate,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 编辑
export const updateCustomerApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerUpdate,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//变更
export const getCustomerModifyCustomerTypesApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerModifyCustomerTypes,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户分配
export const getCustomerAllotActionApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerAllotAction,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取客户属性列表（客户变更|客户新增）
export const getCustomerTypeListApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerTypeList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户同步财务客户
export const getCustomerGetFinanceCustomerApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerGetFinanceCustomer,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 天眼查
export const getCustomerDataApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerData,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

export const customerTransferExamineApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerTransferExamine,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//获取客户权限范围内的客户经理
export const getCustomerOwnersApi = (params: any) =>
  defHttp.post<any>({
    url: Api.GetCustomerOwners,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//更新天眼查数据
export const updateTYCDataApi = (params: any) =>
  defHttp.post<any>({
    url: Api.UpdateTYCData,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//获取客户年度销售额
export const getCustomerYearSalesDataApi = (params: any) =>
  defHttp.post<any>({
    url: Api.GetCustomerYearSales,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//标记淘宝客户
export const ECCustomerHandleApi = (params: any) =>
  defHttp.post<any>({
    url: Api.ECCustomerHandle,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//获取标记的淘宝客户
export const GetECCustomerList = (params: any) =>
  defHttp.post<any>({
    url: Api.GetECCustomerList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//获取创建的企业客户
export const GetCreateCustomerListApi = (params: any) =>
  defHttp.post<any>({
    url: Api.GetCreateCustomerList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//标记重点客户
export const KeyCustomerHandleApi = (params: any) =>
  defHttp.post<any>({
    url: Api.KeyCustomerHandle,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//标记重点客户
export const ActiveCustomerHandleApi = (params: any) =>
  defHttp.post<any>({
    url: Api.ActiveCustomer,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//客户转移导入
export const TransferImportApi = (params: any) =>
  defHttp.post<any>({
    url: Api.TransferImport,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

//客户下单方式变更
export const CustomerOrderWayChangeApi = (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerOrderWayChange,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 根据客户名称获取列表
export const getCustomerByNameApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.GetCustomerByName,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 获取特殊标记客户与订单
export const getSpecialDelayCustomerApi = async (params: any) => {
  const res = await defHttp.post<any>({
    url: Api.GetSpecialDelayCustomer,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
  res.data = dataTimestampToFormat(res.data);
  return res;
};

// 校验订单号是否先生产后付款欠款订单
export const checkDelayOrderByOrderIdApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.CheckDelayOrderByOrderId,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 逾期特殊标记客户与订单保存
export const specialDelayCustomerSaveApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.SpecialDelayCustomerSave,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 逾期特殊标记客户与订单删除
export const specialDelayCustomerDeleteApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.SpecialDelayCustomerDelete,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户分类规则列表
export const customerRuleListApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerRuleList,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户分类规则状态统计
export const customerRuleStatusCountsApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerRuleStatusCounts,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户分类规则保存
export const customerRuleSaveApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerRuleSave,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户分类规则状态变更
export const customerRuleStatusApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerRuleStatus,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });

// 客户分类规则修改记录
export const customerRuleHistoryApi = async (params: any) =>
  defHttp.post<any>({
    url: Api.CustomerRuleHistory,
    params,
    headers: {
      ignoreCancelToken: true,
    },
  });
